import { useSyncExternalStore } from 'react';
import { applyTheme, applyThemeChoice, readThemeChoice, resolveTheme, type ThemeChoice } from '@/theme';

export const themeChoices: readonly { value: ThemeChoice; label: string }[] = [
  { value: 'dark', label: 'Dark' },
  { value: 'light', label: 'Light' },
  { value: 'system', label: 'System' },
];

let current: ThemeChoice | null = null;
const listeners = new Set<() => void>();

export function getThemeChoice(): ThemeChoice {
  current ??= readThemeChoice();
  return current;
}

/** Applies and remembers a theme; the More sheet and the desktop header both show it. */
export function setThemeChoice(choice: ThemeChoice): void {
  current = choice;
  applyThemeChoice(choice);
  for (const listener of listeners) listener();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function serverSnapshot(): ThemeChoice {
  return 'dark';
}

export function useThemeChoice(): ThemeChoice {
  return useSyncExternalStore(subscribe, getThemeChoice, serverSnapshot);
}

/** With "System", follows the device when it switches between light and dark. Returns the stop function. */
export function followSystemTheme(): () => void {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return () => undefined;

  const query = window.matchMedia('(prefers-color-scheme: light)');
  const follow = () => {
    if (getThemeChoice() === 'system') applyTheme(resolveTheme('system'));
  };

  query.addEventListener('change', follow);
  return () => query.removeEventListener('change', follow);
}
